import { getAbTestV2 } from 'dibs-ab-tests/exports/clientAbTestV2';

export const getFdfQuoteABTestVariant = (): string | undefined => {
    return getAbTestV2('fdf-us-row-test-q42023')?.variant;
};
